<template>
	<div class="">
		<base-page-heading
			title="Bulk Discounts"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="bulkDiscountShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row content">
			<BulkDiscountTable
				@routeBulkDiscount="routeBulkDiscount"
			/>
		</div>
	</div>
</template>
